import classnames from 'classnames/bind';
import styles from './profile.module.scss';
const cx = classnames.bind(styles);

interface IProfileProps {
  userName?: string;
  profileImageUrl?: string;
}

const Profile = ({ userName, profileImageUrl }: IProfileProps) => {
  const profileImageStyle = profileImageUrl ? { backgroundImage: `url(${profileImageUrl})` } : {};
  return (
    <div className={cx('profileArea')}>
      <div className={cx('profileInner')}>
        {/* [D] '내 프로필' 처럼 사진이 들어올 수 있을 것 같은데, 확인 한번 부탁드려요. */}
        <span className={cx('profile', { default: !profileImageUrl })} style={profileImageStyle} />
        <div className={cx('nameArea')}>
          <em className={cx('name')}>{userName}</em>
          <span className={cx('text')}>회원님, 안녕하세요!</span>
        </div>
      </div>
    </div>
  );
};

export default Profile;
